import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getCurrent() {
        return axios.get(`${API_URL}/pos/cash-session`, { headers: authHeader() });
    },
    getHistory() {
        return axios.get(`${API_URL}/pos/cash-session/history`, { headers: authHeader() });
    },
    getClosingReport() {
        return axios.get(`${API_URL}/pos/cash-session/closing-report`, { headers: authHeader() });
    },
    getLastClose() {
        return axios.get(`${API_URL}/pos/cash-session/last-close`, { headers: authHeader() });
    },
    open(data) {
        return axios.post(`${API_URL}/pos/cash-session/open`, data, { headers: authHeader() });
    },
    close(data) {
        return axios.post(`${API_URL}/pos/cash-session/close`, data, { headers: authHeader() });
    },
};
